import { render, staticRenderFns } from "./DeniedApplicants.vue?vue&type=template&id=514902e5&"
import script from "./DeniedApplicants.vue?vue&type=script&lang=js&"
export * from "./DeniedApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports